import React from 'react'
import {Page} from 'react-onsenui'
import Loader from 'react-loader-spinner';
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom';
import {NaverMap, Marker, Polyline} from 'react-naver-maps';
import MetaTags from 'react-meta-tags';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import qs from "query-string";

import {showAlertMessage, showAlertMessageWithRedirect} from "../../modules/alert";
import {showToastMessage} from "../../modules/toast";
import {NAVER_THUMBNAIL_GETTER, SVG_MARKER_ICON, GET_HEIGHT_FOR_NAVER_MAP} from "../../modules/variable/common_variable";
import TargetScheduleActionSheetFunctions from '../schedule/module/targetScheduleActionSheetFunctions';
import TargetScheduleActionSheetDescription from "../schedule/module/targetScheduleActionSheetDescription";
import {useCurrentLocation} from "../../modules/native";



class Schedule extends React.Component {
    constructor(props) {
        super(props);
        firebase.firestore().settings({timestampsInSnapshots: true});
        this.scheduleRef = firebase.firestore().collection('user_schedule');

        const queryParams = qs.parse(this.props.location.search);

        let pageTitle = null;
        if(queryParams.title){
            pageTitle = queryParams.title;
        }

        let loadingMessage = null;
        if(queryParams.description){
            try {
                const description = queryParams.description.split(',');
                let lm = [];
                for(let i = 0; i < description.length; i ++){
                    lm.push('#' + description[i]);
                }
                loadingMessage = lm.join(' ');
            } catch (e) {
                loadingMessage = null;
            }
        }

        let loadingImage = null;
        if(queryParams.imageSrc){
            try {
                loadingImage = NAVER_THUMBNAIL_GETTER({imageSrc: queryParams.imageSrc});
            } catch (e) {
                loadingImage = null;
            }
        }

        this.state = {
            openSideMenu: false,
            queryParams: queryParams,
            targetSchedulePage: {open: false, title: '', data: null, polyLine: [], mapCenter: {lat: 37.554690, lng: 126.970702}, targetToMapCenter: null, targetNaverPlaceActionSheet: null, tab: 'schedule'},
            pageTitle: pageTitle,
            loadingMessage: loadingMessage,
            loadingImage: loadingImage
        };
    }

    naverMaps = window.naver.maps;

    componentDidMount(){
        //anonymous login if user is not logged in
        setTimeout(() => {
            if(!this.props.userInfo.isSignedIn){
                firebase.auth().signInAnonymously().catch(function(error) {
                    console.error(error);
                });
            }
        }, 5000);

        this.getSchedule();
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.usedCurrentLocation === true && nextProps.usedCurrentLocation === false){
            this.setTargetToMapCenter(null, nextProps.currentLocation);
            this.props.useCurrentLocation();
        }
    }

    getSchedule = () => {
        const docId = this.state.queryParams.docId;
        if(docId){
            const query = this.scheduleRef.doc(docId);
            query.get().then((doc) => {
                if(doc.exists){
                    let d = doc.data();
                    d['DOC_ID'] = doc.id;

                    if(!d.use || !d.share){
                        this.props.showAlertMessageWithRedirect("일정 정보가 삭제되었거나 공개되지 않았습니다.", "/intro");
                    }

                    this.showTargetSchedule(d);
                }else{
                    this.props.showAlertMessageWithRedirect("일정 정보가 없습니다.", "/intro");
                }
            });
        }else{
            this.props.showAlertMessageWithRedirect("잘못된 경로로 접근하였습니다.", "/intro");
        }
    };

    showTargetSchedule = (target) => {
        let naverMapPolyLineList = [];
        target.scheduleOrder.map((e) => {
            const so = target.schedule[e];
            naverMapPolyLineList.push(new this.naverMaps.LatLng(so.y, so.x));
        });
        const firstSchedule = target.schedule[target.scheduleOrder[0]];
        this.setState({targetSchedulePage: {...this.state.targetSchedulePage, open: true, title: target.title, data: target, polyLine: naverMapPolyLineList, mapCenter:{lat: firstSchedule.y, lng: firstSchedule.x}}});
    };

    showNaverPlaceInFunctions = (marker) => {
        this.setState({targetSchedulePage: {...this.state.targetSchedulePage, targetNaverPlaceActionSheet: {targetMarker: marker, open: true, isLoading: false, data: null}}});
    };

    setTargetToMapCenter = (event, target) => {
        if(event){
            event.preventDefault();
            event.stopPropagation();
        }

        const mapCenter = {y: target.y, x: target.x, lat: target.y, lng: target.x};
        this.setState({targetSchedulePage: {...this.state.targetSchedulePage, mapCenter: mapCenter, targetToMapCenter: mapCenter}});
        setTimeout(() => {
            this.setState({targetSchedulePage: {...this.state.targetSchedulePage, targetToMapCenter: null}});
        }, 2000)
    };

    requestCurrentLocation = () => {
        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_CURRENT_LOCATION'});
            window.postMessage(message, "*");
        }else{
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const gpsLocation = {y: position.coords.latitude, x: position.coords.longitude, lat: position.coords.latitude, lng: position.coords.longitude};
                    this.setTargetToMapCenter(null, gpsLocation);
                    localStorage.setItem('savedGpsLocation', JSON.stringify(gpsLocation));
                }, (error) => {
                    console.error(error);
                    this.props.showToastMessage('위치 정보를 확인하는 과정에서 오류가 발생하였습니다.');
                }, {
                    enableHighAccuracy: false,
                    maximumAge: 0,
                    timeout: Infinity
                });
            } else {
                this.props.showToastMessage('본 기기가 GPS를 지원하지 않습니다.');
            }
        }
    };

    render() {
        const TSP = this.state.targetSchedulePage;

        return (
            <Page>
                <MetaTags>
                    <title>피크니키: 나들이 어디로 갈까?</title>
                    {
                        this.state.loadingMessage ?
                            <meta name="og:description" content={this.state.loadingMessage} />
                            :
                            null
                    }
                    {
                        this.state.pageTitle ?
                            <meta property="og:title" content={this.state.pageTitle} />
                            :
                            null
                    }
                    {
                        this.state.loadingImage ?
                            <meta property="og:image" content={this.state.loadingImage} />
                            :
                            null
                    }
                </MetaTags>

                {
                    TSP.open ?
                        <div className="target-schedule-action-sheet target-schedule-action-sheet-on-page">
                            <div className="action-sheet-title action-sheet-title--material">
                                {TSP.title}
                            </div>
                            <div className="segment segment--material">
                                <div className="segment__item segment--material__item">
                                    <input type="radio" className="segment__input segment--material__input" name="target-schedule-segment" checked={TSP.tab === 'schedule'} onChange={() => this.setState({targetSchedulePage: {...this.state.targetSchedulePage, tab: 'schedule'}})}/>
                                    <div className="segment__button segment--material__button TUTO_SCHEDULE_TAB_BUTTON">{'지도 + 장소'}</div>
                                </div>
                                <div className="segment__item segment--material__item">
                                    <input type="radio" className="segment__input segment--material__input TUTO_SCHEDULE_DESCRIPTION_TAB_INPUT" name="target-schedule-segment" checked={TSP.tab === 'description'} onChange={() =>  this.setState({targetSchedulePage: {...this.state.targetSchedulePage, tab: 'description'}})}/>
                                    <div className="segment__button segment--material__button TUTO_SCHEDULE_DESCRIPTION_TAB_BUTTON">{'설명 + 댓글'}</div>
                                </div>
                            </div>
                            <div className="card card--material" style={{display: TSP.tab === 'schedule' ? '' : 'none'}}>
                                <NaverMap
                                    id={'naver-map-for-outbound'}
                                    className={'naver--map create-plan-naver-map-for-target TUTO_NAVER_MAP'}
                                    naverRef={ref => { this.naverMapRef = ref }}
                                    style={{width: window.innerWidth, height: GET_HEIGHT_FOR_NAVER_MAP(window.screenSizeProperty === 'md' ? 450 : 250)}}
                                    defaultZoom={8}
                                    minZoom={3}
                                    maxZoom={14}
                                    zoomControl={true}
                                    zoomControlOptions={
                                        {position: this.naverMaps.Position.TOP_RIGHT, style: this.naverMaps.ZoomControlStyle.SMALL, legendDisabled: false}
                                    }
                                    center={TSP.mapCenter}
                                    onCenterChanged={center => this.setState({targetSchedulePage: {...this.state.targetSchedulePage, mapCenter: center}})}
                                    logoControl={false}
                                    mapDataControl={false}
                                >
                                    <button className="button button--material--flat map-current-button" onClick={this.requestCurrentLocation}>
                                        <i className="ion ion-android-locate"/>
                                    </button>

                                    {
                                        TSP.open ?
                                            TSP.data.scheduleOrder.map((key, i) => {
                                                return (
                                                    <Marker key={['scheduled', 'marker', key, i].join('_')}
                                                            position={new this.naverMaps.LatLng(TSP.data.schedule[key].y, TSP.data.schedule[key].x)}
                                                            icon= {
                                                                {content: ['<div class="naver-map-pin-mine"',
                                                                        'id="',
                                                                        ['scheduled', 'marker', key, i].join('_'),
                                                                        '">',
                                                                        '<strong>',
                                                                        i + 1,
                                                                        '</strong>',
                                                                        SVG_MARKER_ICON[TSP.data.schedule[key].type],
                                                                        '</div>'].join('')}
                                                            }
                                                            onClick={(event) => {
                                                                this.showNaverPlaceInFunctions(TSP.data.schedule[key])
                                                            }}
                                                    />
                                                )
                                            })
                                            :
                                            null
                                    }

                                    {
                                        TSP.targetToMapCenter ?
                                            <Marker position={new this.naverMaps.LatLng(TSP.targetToMapCenter.y, TSP.targetToMapCenter.x)}
                                                    icon= {{content: ['<div class="naver-map-target-to-map-center"', '</div>'].join('')}}
                                            />
                                            :
                                            null
                                    }

                                    {
                                        TSP.open ?
                                            <Polyline
                                                path={TSP.polyLine}
                                                strokeColor={'#ffe336'}
                                                strokeStyle={'solid'}
                                                strokeOpacity={0.8}
                                                strokeWeight={3}
                                            />
                                            :
                                            null
                                    }
                                </NaverMap>

                                <ul className="list list--material target-schedule-list TUTO_SCHEDULE_LIST">
                                    {
                                        TSP.open ?
                                            TSP.data.scheduleOrder.map((key, i) => {
                                                const e = TSP.data.schedule[key];
                                                return (
                                                    <li key={['list', key, i].join('_')} className="list-item list-item--material">
                                                        <div className="list-item__left list-item--material__left" onClick={() => this.showNaverPlaceInFunctions(e)}>
                                                            <img className="list-item__thumbnail"
                                                                 src={NAVER_THUMBNAIL_GETTER(e)} onError={(event)=>{event.target.src = "https://fakeimg.pl/100x100/?text=No Image"}} alt={e.name}/>
                                                        </div>
                                                        <div className="list-item__center list-item--material__center" onClick={() => this.showNaverPlaceInFunctions(e)}>
                                                            <div className="list-item__title list-item--material__title">{i + 1}. {e.name} {e.category ? <small>{e.category}</small>: null}</div>
                                                            <div className="list-item__subtitle list-item--material__subtitle">{e.tags ? e.tags.join(", ") : null}</div>
                                                        </div>
                                                        <div className="list-item__right list-item--material__right" onClick={(event) => this.setTargetToMapCenter(event, e)}>
                                                            <span><i className="fa fa-map-marker-alt"/></span>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                            :
                                            null
                                    }
                                </ul>

                                {
                                    TSP.open ?
                                        <TargetScheduleActionSheetFunctions isolated={true} TSAS={TSP} hideTNPAS={() => this.setState({targetSchedulePage: {...this.state.targetSchedulePage, targetNaverPlaceActionSheet: null}})}/>
                                        :
                                        null
                                }
                            </div>

                            {
                                TSP.open && TSP.tab === 'description' ?
                                    <div className="card card--material target-schedule-description-wrapper">
                                        <TargetScheduleActionSheetDescription TSAS={TSP}/>
                                    </div>
                                    :
                                    <div/>
                            }

                        </div>
                        :
                        <div className="loader-puff">
                            <Loader type="ThreeDots" color="#00BFFF" height={80} width={80} />
                            <p>일정 정보 확인중</p>
                        </div>
                }

            </Page>
        )
    }
}

const mapStateToProps = ({user, native}) => ({
    userInfo: user.userInfo,
    usedCurrentLocation: native.usedCurrentLocation,
    currentLocation: native.currentLocation,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showAlertMessageWithRedirect: (message, url) => dispatch(showAlertMessageWithRedirect(message, url)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    useCurrentLocation: () => dispatch(useCurrentLocation()),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Schedule))